import React, { Component } from "react";

import * as actions from "../../actions";
import { connect } from "react-redux";
import EkoDataTable from "../../components/elements/EkoDataTable";
import Api from "../../util/Api";
import Style from "style-it";
import { CSS } from "../../css/tab_datatable";
import DataHelper from "../../services/DataHelper";

class OutstandingCollections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payments: [],
      loading: true
    };
  }

  fetchPayments() {
    Api.get("/supplier/outStandingPurchaseInvoices", (response, error) => {
      console.log(response);

      this.setState({
        loading: false,
        payments: DataHelper.getOutstandingData(
          response.outStandingPurchaseInvoices
        )
      });
    });

    //this.props.fetchData("/collection/list", FETCH_COLLECTIONS);
  }

  componentWillMount() {
    this.fetchPayments();
  }

  openUpdate(selectedRow) {
    //this.props.router.push   ('/dashboard/collections/edit/' + selectedRow.id);
  }

  openInsert(menuItem) {
    // this.props.router.push   ('/dashboard/collections/add');
  }

  onDelete(selectedRow) {}

  get items() {
    return [
      {
        id: 1,
        link: "/dashboard/payments",
        title: "Ödediklerim"
      },

      {
        id: 2,
        link: "/dashboard/payments/outstanding",
        title: "Borçlarım"
      }
    ];
  }

  render() {
    console.log(this.state);
    const insertMenu = this.props.viewOptions
      ? this.props.viewOptions.collections.type
      : false;
    return (
      <div>
        {Style.it(
          CSS,
          <div>
            <EkoDataTable
              addUpdateShow={false}
              addButtonShow={false}
              showDelete={false}
              tabMenu={this.items}
              hideExportMenu
              selectedTab={2}
              dtConfigLocal={{
                date_filter_column: "dueDate",
                has_search: true
              }}
              headers={[
                {
                  id: 1,
                  header_name: "Kime",
                  column_name: "supplierName",
                  status: 1
                },
                {
                  id: 2,
                  header_name: "Vade Tarihi",
                  column_name: "dueDate",
                  status: 1
                },
                {
                  id: 3,
                  header_name: "Tutar",
                  column_name: "amount",
                  status: 1
                },
                {
                  id: 4,
                  header_name: "Durum",
                  column_name: "dueDaysString",
                  status: 1
                }
              ]}
              title={"Yapılacak Ödemeler"}
              openInsert={this.openInsert.bind(this)}
              openUpdate={this.openUpdate.bind(this)}
              onDelete={this.onDelete.bind(this)}
              data={this.state.payments}
              insertMenu={insertMenu}
              name={"outstanding_payments"}
            ></EkoDataTable>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    // outstanding: state.fetch.outstanding,
    // outstanding_loading: state.fetch.outstanding_loading,
    viewOptions: state.data.viewOptions
  };
}

export default connect(mapStateToProps, actions)(OutstandingCollections);
